<script>

    import configuration from '../configuration.json';
    import { renderMarkdown, renderPlain } from '../helpers/markdown.js';

    let { source = '' } = $props();

    // Global feature toggle: full basic formatting when on, escaped plain text
    // (line breaks preserved) when off. Either way the output is safe for {@html}.
    const enabled = configuration['render-markdown'] === true;

    let html = $derived(enabled ? renderMarkdown(source) : renderPlain(source));

</script>

<!-- Render nothing for empty/whitespace source, so a call-site wrapper stays :empty
     (e.g. the treatment card hides an empty description via .description:empty). -->
{#if source && source.trim()}
    <div class="markdown">{@html html}</div>
{/if}

<style>

    /* The {@html} content is not Svelte-scoped, so target it via :global under the
       component's own .markdown container — the styling stays internal to <Markdown>.
       Only block spacing lives here; the caller keeps its own font-size/colour. */

    .markdown :global(p) {
        margin: 0 0 0.6em;
    }

    .markdown :global(p:last-child) {
        margin-bottom: 0;
    }

    .markdown :global(ul),
    .markdown :global(ol) {
        margin: 0.5em 0;
        padding-left: 1.4em;
    }

    .markdown :global(ul:last-child),
    .markdown :global(ol:last-child) {
        margin-bottom: 0;
    }

    .markdown :global(li) {
        margin: 0.2em 0;
    }

    .markdown :global(strong) {
        font-weight: 600;
    }

    .markdown :global(em) {
        font-style: italic;
    }

</style>
